import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ServicesSection.css";

const ServicesSection = () => {
  const services = [
    {
      title: "Corporate cab service in pune",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Pune with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/1.jpg",
      link: "/booking",
    },
    {
      title: " Corporate Cab Services in Delhi",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Delhi with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/56.jpg",
      link: "/booking",
    },
    {
      title: " Corporate Cab Services in Bangalore",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Bangalore with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/61.jpg",
      link: "/booking",
    },
    {
      title: "Corporate Cab Services in Chennai",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Chennai with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/23.jpg",
      link: "/booking",
    },
    {
      title: "Corporate Cab Service in Jaipur",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Jaipur with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/53.jpg",
      link: "/booking",
    },
    {
      title: "Corporate Cab Service in Hyderabad",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Hyderabad with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/7.jpg",
      link: "/booking",
    },
  ];

  return (

<>


 <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Services</h1>
          </div>
        </div>
      </section>


    <section className="services-section py-5">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="service-card shadow-sm h-100">
                <img src={service.image} alt={service.title} className="img-fluid" />
                <div className="p-3">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-desc">{service.description}</p>
                  <a href={service.link} className="book-btn btn btn-warning w-100">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

</>
  );
};

export default ServicesSection;
